import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Navigation from "../Navigations/MainNavigation";
import RulesNav from "./Nav";
import Footer from "../Footer";

import styled from "styled-components";
const ContainerMain = styled.div`
  width: 100%;
`;
const Container = styled.div`
  width: 80%;
  height: 1300px;
  margin-left: 10%;
  padding-top: 100px;
  @media (max-width: 768px) {
    height: 1800px;
    width: 90%;

    margin-left: 5%;
  }
`;
const Nav = styled.div`
  width: 20%;
  height: 100%;
  float: left;
  @media (max-width: 768px) {
    display: none;
  }
`;

const MainContent = styled.div`
  width: 78%;
  height: 100%;
  float: right;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
const Title = styled.h1`
  font-weight: 600;
  font-size: 2em;
  margin: 0;
  padding: 0;
`;
const SubTitle = styled.h2`
  font-weight: 600;
  font-size: 1.2em;
  margin: 30px 0 10px 0;
  padding: 0;
`;
const TextBlock = styled.p`
  color: #636161;
`;
const ListItem = styled.li`
  color: #636161;
  margin: 0 0 10px 0;
`;
function FAQ() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <ContainerMain>
      <Navigation />
      <Container>
        <Nav>
          <RulesNav />
        </Nav>
        <MainContent>
          <Title>Frequently Asked Question</Title>
          <SubTitle>1. How does Maplun build trust?</SubTitle>
          <TextBlock>
            Maplun.com helps connect buyers and sellers with true product and
            seller information by verified sellers across the country. It is a
            PhysiTal (Physical + Digital) marketplace where shops or sellers
            must be physically and locally existing. Before buying, most of the
            buyers visit online to select brand, model, functionality, price,
            store and their available nearby locations. Having a nearby physical
            shop creates a trust between buyers and sellers. At Maplun.com, we
            never allow virtual shop or virtual seller.
          </TextBlock>
          <SubTitle>2. How to deliver or ship products?</SubTitle>
          <TextBlock>
            Maplun does not take responsibility of any delivery or courier
            service. All the individual buyers and sellers are solely held
            responsible for their deals in pricing, timing, product delivery,
            security etc. As the platform, we do not store products and
            henceforth do not deliver products by our own. These dealings will
            be made with consensus between buyers and sellers with their own
            responsibilities.
          </TextBlock>
          <SubTitle>
            3. What are the prohibited actions on this marketplace?
          </SubTitle>
          <TextBlock>
            At Maplun, any product i.e. stolen, snatched, robbed or any illegal
            ways of campaigning for buying-selling is prohibited. Any fraudulent
            activity, unfair competition, absurd offer, or false advertisement,
            post, information, account, picture, personation, NID information,
            communication, transaction etc are strictly prohibited. We reserve
            the right to delete any account if the user violates these terms.
          </TextBlock>
          <SubTitle>4. Is my input information safe?</SubTitle>
          <TextBlock>
            Yes. All the information you provided in your account is safe in our
            custody. We do not breach any trust or contract made with any user,
            buyer or seller, advertiser or promoter.
          </TextBlock>
          <SubTitle>5. Why do you shop from Maplun?</SubTitle>
          <TextBlock>
            In this marketplace, visitors can easily summarize their choices to
            take buying decision and sellers can quickly increase their sales by
            reaching to so many potential buyers. As the platform, we help
            connect buyers and sellers with effective innovative ideas in many
            ways.
          </TextBlock>
          <SubTitle>6. Are the products genuine or covering warranty?</SubTitle>
          <TextBlock>
            In this marketplace, there are all physical shops. Whoever works
            over the platform will be his/her personal matter therein. A
            customer can ask shop owners/sellers if they offer:
          </TextBlock>
          <ListItem>Exchange or return policy, if so?</ListItem>
          <ListItem>Conditions for returns or exchanges, if so?</ListItem>
          <ListItem>Product warranty, guarantee, if so?</ListItem>
          <ListItem>Product genuine or not?</ListItem>
          <TextBlock>
            No how Maplun will be held responsible or be claimed for any
            product/service quality, damage, transaction or other issues. It is
            just an online marketplace like a physical market where buyers and
            sellers deal one to one for trading and transacting. We are neither
            taking any responsibility of any trade nor the party of any dispute
            or settlement.
          </TextBlock>
          <SubTitle>7. How Maplun does ensures compliance?</SubTitle>
          <TextBlock>
            In general, the meaning of theft; is a theft in this platform as
            well, the meaning of fraud; is a fraud in this platform as well. All
            the users (buyers, sellers and post makers) must follow the rules,
            regulations and related laws of the trade, transaction,
            telecommunication, mobile device and all other legal aspects. Along
            with the ICT, ecommerce and other directly connected laws, there are
            many applicable laws relevant with users’ behavior as contract act,
            sales of goods act, copyright act, penal code, evidence act, CPC,
            CrPC etc.
          </TextBlock>
        </MainContent>
      </Container>
      <Footer />
    </ContainerMain>
  );
}

export default FAQ;
